<template>
	<div class="survey">
		<div class="survey-container">
			<div class="d-flex justify-space-between mb-7">
				<div>
					<h2 class="mr-5">Enkät om resvanor</h2>
					<p>– tack för att du bidrar!</p>
				</div>
				<div>
          <img
            width="119"
            :src="$apiUrl + '/storage/CLQ4NvrdRsUlnUhiUZxpVHAqzwXbVqDvpL2uvjv8.jpg'"
            alt="Region Gotland Logo"
          />
				</div>
			</div>


<!-- Page 1: BEHAVIOR COMMUTING					-->
			<div v-if="stepIndex === 0">
				<p>
					I denna enkät får du svara på hur ditt vardagsresande ser ut idag. Dina svar är värdefulla – oavsett om du färdas långt, kort, ofta eller sällan. Med hjälp av dina svar kan vi skapa ännu bättre förutsättningar för smart resande åt dig och oss alla.
				</p>
				<p>Det går snabbt att svara. Tack för att du deltar.</p>
				<p>
					Undersökningen genomförs av Nudgd på uppdrag av RegionGotland och GotlandsHem. Här kan du läsa om hur <a :href="$processText('https://data.nudgd.se/{slug}')">dina personuppgifter hanteras.</a>
				</p>


				<h2 class="mt-10 mb-2">Hur brukar du färdas <span style="color: #00A9CE;">till och från JOBBET</span>?</h2>
				<p class="mb-0"><em class="smaller-em">Fundera på vad som känns rimligt och fyll i det du tror.</em></p>


				<h4 class="mt-3 mb-3" :class="{surveyError: errors.includes('previousMainModeOfTransport')}">Vad anser du vara ditt huvudsakliga färdsätt?</h4>

				<ModeOfTransport :key="1" :value="previousMainModeOfTransport" @selected="selectModeOfTransport" />

				<div class="nudgd-btn inline survey-submit mt-5" @click="confirmFirstStep()" v-if=" ! firstStepConfirmed">Gå vidare</div>
				<div style="clear:both;"></div>

				<template v-if="firstStepConfirmed">

					<h4 class="mt-2 mb-3">Hur många dagar per vecka använde du följande färdsätt, i genomsnitt, <span style="color: #00A9CE;">till/från jobbet</span>?</h4>
					<p class="mb-2"><em class="smaller-em">(Använder du olika färdmedel för samma resa så räkna med alla. Runda av till närmaste heltal, t.ex. om du bara använder bil tre gånger per månad blir det 3/4 = 0,75 –> 1. Vänligen svara på alla.)</em></p>
					<div class="survey-frequency-chips walk">
						<h3 :class="{surveyError: errors.includes('previousFrequencyWalk')}">🚶 Till fots</h3>
						<div class="survey-frequency-chips-container">
							<div class="survey-frequency-chips-container-chip walking" :class="{active: previousFrequencyWalk == number}" v-for="number in [0, 1, 2, 3, 4, 5, 6, 7]" :key="number" @click="selectFrequency('previousFrequencyWalk', number)">{{ number }}</div>
						</div>
						<div class="survey-frequency-chips-helpers right">
							<div>dagar per vecka</div>
						</div>
					</div>
					<div class="survey-frequency-chips">
						<h3 :class="{surveyError: errors.includes('previousFrequencyBike')}">🚲 Cykel</h3>
						<div class="survey-frequency-chips-container">
							<div class="survey-frequency-chips-container-chip bike" :class="{active: previousFrequencyBike == number}" v-for="number in [0, 1, 2, 3, 4, 5, 6, 7]" :key="number" @click="selectFrequency('previousFrequencyBike', number)">{{ number }}</div>
						</div>
						<div class="survey-frequency-chips-helpers right">
							<div>dagar per vecka</div>
						</div>
					</div>
					<div class="survey-frequency-chips">
						<h3 :class="{surveyError: errors.includes('previousFrequencyTransit')}">🚌 Kollektivt</h3>
						<div class="survey-frequency-chips-container">
							<div class="survey-frequency-chips-container-chip transit" :class="{active: previousFrequencyTransit == number}" v-for="number in [0, 1, 2, 3, 4, 5, 6, 7]" :key="number" @click="selectFrequency('previousFrequencyTransit', number)">{{ number }}</div>
						</div>
						<div class="survey-frequency-chips-helpers right">
							<div>dagar per vecka</div>
						</div>
					</div>
					<div class="survey-frequency-chips">
						<h3 :class="{surveyError: errors.includes('previousFrequencyCar')}">🚗 Bil - själv/med hushållsmedlem</h3>
						<div class="survey-frequency-chips-container">
							<div class="survey-frequency-chips-container-chip car" :class="{active: previousFrequencyCar == number}" v-for="number in [0, 1, 2, 3, 4, 5, 6, 7]" :key="number" @click="selectFrequency('previousFrequencyCar', number)">{{ number }}</div>
						</div>
						<div class="survey-frequency-chips-helpers right">
							<div>dagar per vecka</div>
						</div>
					</div>
					<div class="survey-frequency-chips">
						<h3 :class="{surveyError: errors.includes('previousFrequencyCarCoride')}">🚙 Bil - samåkning med annan</h3>
						<div class="survey-frequency-chips-container">
							<div class="survey-frequency-chips-container-chip car" :class="{active: previousFrequencyCarCoride == number}" v-for="number in [0, 1, 2, 3, 4, 5, 6, 7]" :key="number" @click="selectFrequency('previousFrequencyCarCoride', number)">{{ number }}</div>
						</div>
						<div class="survey-frequency-chips-helpers right">
							<div>dagar per vecka</div>
						</div>
					</div>
					<div class="survey-frequency-chips">
						<h3 :class="{surveyError: errors.includes('previousFrequencyMisc')}">Övrigt</h3>
						<div class="survey-frequency-chips-container">
							<div class="survey-frequency-chips-container-chip" :class="{active: previousFrequencyMisc == number}" v-for="number in [0, 1, 2, 3, 4, 5, 6, 7]" :key="number" @click="selectFrequency('previousFrequencyMisc', number)">{{ number }}</div>
						</div>
						<div class="survey-frequency-chips-helpers right">
							<div>dagar per vecka</div>
						</div>
					</div>


					<template v-if="previousFrequencyWalk || previousFrequencyBike || previousFrequencyCar || previousFrequencyCarCoride || previousFrequencyTransit || previousFrequencyMisc">
						<h4 class="mt-2 mb-1">Hur många gånger per vecka färdas du, i genomsnitt, <span style="color: #00A9CE;">till/från jobbet</span>?</h4>
						<p class="mb-2"><em class="smaller-em">(Tur och retur räknas alltså som en gång. Räkna även med de gånger då du färdas till någon annan plats på vägen till eller från jobbet.)</em></p>

						<div class="survey-thirds mt-3">
							<div class="survey-thirds-first" :class="{surveyError: errors.includes('previousNumberOfTrips')}">Antal resor:</div>

							<div class="survey-thirds-middle">
								<vue-slider dotSize="20" :max="35" v-model="previousNumberOfTrips"></vue-slider>
							</div>

							<div class="survey-thirds-last"><v-text-field placeholder="0" v-model.number="previousNumberOfTrips"></v-text-field> resor</div>
						</div>



						<h4 class="mt-6 mb-6">Hur långt färdas du med följande färdsätt, i genomsnitt, <span style="color: #00A9CE;">till/från jobbet</span>?</h4>
							<p class="mb-2"><em class="smaller-em">(Räkna med både vägen dit och vägen tillbaka, inklusive avståndet till andra platser du färdas till på vägen till eller från jobbet.)</em></p>
						<div class="survey-thirds walking mt-3">
							<div class="survey-thirds-first-alt" :class="{surveyError: errors.includes('previousWeeklyWalking')}">Till fots</div>
							<div class="survey-thirds-middle"><vue-slider :max="200" v-model="previousWeeklyWalking"><template v-slot:dot><div class="custom-dot alt">🚶</div></template></vue-slider></div>
							<div class="survey-thirds-last"><v-text-field hide-details v-model.number="previousWeeklyWalking"></v-text-field> km</div>
						</div>

						<div class="survey-thirds bike mt-3">
							<div class="survey-thirds-first-alt" :class="{surveyError: errors.includes('previousWeeklyBike')}">Cykel</div>
							<div class="survey-thirds-middle"><vue-slider :max="200" v-model="previousWeeklyBike"><template v-slot:dot><div class="custom-dot alt">🚲</div></template></vue-slider></div>
							<div class="survey-thirds-last"><v-text-field hide-details v-model.number="previousWeeklyBike"></v-text-field> km</div>
						</div>

						<div class="survey-thirds transit mt-3">
							<div class="survey-thirds-first-alt" :class="{surveyError: errors.includes('previousWeeklyTransit')}">Kollektivt</div>
							<div class="survey-thirds-middle"><vue-slider :max="1000" v-model="previousWeeklyTransit"><template v-slot:dot><div class="custom-dot alt">🚌</div></template></vue-slider></div>
							<div class="survey-thirds-last"><v-text-field hide-details v-model.number="previousWeeklyTransit"></v-text-field> km</div>
						</div>

						<div class="survey-thirds car mt-3">
							<div class="survey-thirds-first-alt" :class="{surveyError: errors.includes('previousWeeklyCar')}">Bil - själv/med hushållsmedlem</div>
							<div class="survey-thirds-middle"><vue-slider :max="1000" v-model="previousWeeklyCar"><template v-slot:dot><div class="custom-dot alt">🚗</div></template></vue-slider></div>
							<div class="survey-thirds-last"><v-text-field hide-details v-model.number="previousWeeklyCar"></v-text-field> km</div>
						</div>

						<div class="survey-thirds carCoride mt-3">
							<div class="survey-thirds-first-alt" :class="{surveyError: errors.includes('previousWeeklyCarCoride')}">Bil - samåkning med annan</div>
							<div class="survey-thirds-middle"><vue-slider :max="1000" v-model="previousWeeklyCarCoride"><template v-slot:dot><div class="custom-dot alt">🚙</div></template></vue-slider></div>
							<div class="survey-thirds-last"><v-text-field hide-details v-model.number="previousWeeklyCarCoride"></v-text-field> km</div>
						</div>

						<div class="survey-thirds misc mt-3">
							<div class="survey-thirds-first-alt" :class="{surveyError: errors.includes('previousWeeklyMisc')}">
								<v-tooltip bottom>
							      <template v-slot:activator="{ on, attrs }"><span v-bind="attrs" v-on="on">Övrigt <div class="tooltip-container"><span class="icon-info"></span></div></span></template>
							      <span>t.ex. elsparkcykel, skateboard etc."</span>
							    </v-tooltip>
							</div>
							<div class="survey-thirds-middle"><vue-slider dotSize="20" :max="200" v-model="previousWeeklyMisc"></vue-slider></div>
							<div class="survey-thirds-last"><v-text-field hide-details v-model.number="previousWeeklyMisc"></v-text-field> km</div>
						</div>

						<div class="survey-thirds-sum"><strong>SUMMA</strong> <span>{{ previousWeeklySum }} km</span></div>

						<div class="survey-sum mt-6"><strong>Din genomsnittliga resa <span style="color: #00A9CE;">till/från jobbet</span> är {{ computedWeeklyAverage }} km</strong> och du färdas <strong>{{ previousWeeklySum }} km per vecka</strong>, vilket blir <strong>{{ yearlyDistance }} km utslaget på ett år</strong> (ifall du färdas likadant alla veckor om året).
							<br/>
							<br/>
							<em>Om reslängden per vecka verkar rimlig, vänligen gå vidare i enkäten. Om inte, justera i frågorna ovan.</em></div>


						<div v-if="previousWeeklyCar">
							<h4 class="mt-5">Hur är dina bilresor fördelade utifrån drivmedel?</h4>
							<p class="mb-2"><em class="smaller-em">(Summan för de olika drivmedlen måste matcha med Bil - själv/med hushållsmedlem ovan ({{ previousWeeklyCar }} km))</em></p>

							<div class="survey-thirds electricity mt-3">
								<div class="survey-thirds-first-alt" :class="{surveyError: errors.includes('previousWeeklyElectricity')}">El</div>
								<div class="survey-thirds-middle"><vue-slider dotSize="20" :max="1000" v-model="previousWeeklyElectricity"></vue-slider></div>
								<div class="survey-thirds-last"><v-text-field hide-details v-model.number="previousWeeklyElectricity"></v-text-field> km</div>
							</div>

							<div class="survey-thirds hybrid mt-3">
								<div class="survey-thirds-first-alt" :class="{surveyError: errors.includes('previousWeeklyHybrid')}">Hybrid/gas</div>
								<div class="survey-thirds-middle"><vue-slider dotSize="20" :max="1000" v-model="previousWeeklyHybrid"></vue-slider></div>
								<div class="survey-thirds-last"><v-text-field hide-details v-model.number="previousWeeklyHybrid"></v-text-field> km</div>
							</div>

							<div class="survey-thirds gas mt-3">
								<div class="survey-thirds-first-alt" :class="{surveyError: errors.includes('previousWeeklyGas')}">Bensin/diesel<br/>/etanol</div>
								<div class="survey-thirds-middle"><vue-slider dotSize="20" :max="1000" v-model="previousWeeklyGas"></vue-slider></div>
								<div class="survey-thirds-last"><v-text-field hide-details v-model.number="previousWeeklyGas"></v-text-field> km</div>
							</div>
						</div>
					</template>

					<div class="nudgd-btn inline survey-submit mt-10" @click="nextStep()">Gå vidare</div>
					<div style="clear:both;"></div>
				</template>
			</div>


<!-- Page 2: BEHAVIOR SPARE TIME 					-->

			<div v-if="stepIndex === 1">
				<h2 class="mt-10 mb-2">Hur brukar du färdas <span style="color: #0B24FB;">på FRITIDEN</span>?</h2>
				<p class="mb-0"><em class="smaller-em">Tänk på en genomsnittlig vecka. Räkna med helger, men inte långresor på semester och dylikt.</em></p>


				<h4 class="mt-3 mb-3" :class="{surveyError: errors.includes('previousLeisureMainModeOfTransport')}">Vad anser du vara ditt huvudsakliga färdsätt för <span style="color: #0B24FB;">dina fritidsresor</span>?</h4>
				<ModeOfTransport :value="previousLeisureMainModeOfTransport" :key="2" @selected="selectLeisureModeOfTransport" />

				<h4 class="mt-2 mb-3">Hur många dagar per vecka använde du följande färdsätt, i genomsnitt, för <span style="color: #00A9CE;">dina fritidsresor</span>?</h4>
				<p class="mb-2"><em class="smaller-em">(Använder du olika färdmedel för samma resa så räkna med alla. Runda av till närmaste heltal, t.ex. om du bara använder bil tre gånger per månad blir det 3/4 = 0,75 –> 1. Vänligen svara på alla.)</em></p>
				<div class="survey-frequency-chips walk">
					<h3 :class="{surveyError: errors.includes('previousLeisureFrequencyWalk')}">🚶 Till fots</h3>
					<div class="survey-frequency-chips-container">
						<div class="survey-frequency-chips-container-chip walking" :class="{active: previousLeisureFrequencyWalk == number}" v-for="number in [0, 1, 2, 3, 4, 5, 6, 7]" :key="number" @click="selectFrequency('previousLeisureFrequencyWalk', number)">{{ number }}</div>
					</div>
					<div class="survey-frequency-chips-helpers right">
						<div>dagar per vecka</div>
					</div>
				</div>
				<div class="survey-frequency-chips">
					<h3 :class="{surveyError: errors.includes('previousLeisureFrequencyBike')}">🚲 Cykel</h3>
					<div class="survey-frequency-chips-container">
						<div class="survey-frequency-chips-container-chip bike" :class="{active: previousLeisureFrequencyBike == number}" v-for="number in [0, 1, 2, 3, 4, 5, 6, 7]" :key="number" @click="selectFrequency('previousLeisureFrequencyBike', number)">{{ number }}</div>
					</div>
					<div class="survey-frequency-chips-helpers right">
						<div>dagar per vecka</div>
					</div>
				</div>
				<div class="survey-frequency-chips">
					<h3 :class="{surveyError: errors.includes('previousLeisureFrequencyTransit')}">🚌 Kollektivt</h3>
					<div class="survey-frequency-chips-container">
						<div class="survey-frequency-chips-container-chip transit" :class="{active: previousLeisureFrequencyTransit == number}" v-for="number in [0, 1, 2, 3, 4, 5, 6, 7]" :key="number" @click="selectFrequency('previousLeisureFrequencyTransit', number)">{{ number }}</div>
					</div>
					<div class="survey-frequency-chips-helpers right">
						<div>dagar per vecka</div>
					</div>
				</div>
				<div class="survey-frequency-chips">
					<h3 :class="{surveyError: errors.includes('previousLeisureFrequencyCar')}">🚗 Bil - själv/med hushållsmedlem</h3>
					<div class="survey-frequency-chips-container">
						<div class="survey-frequency-chips-container-chip car" :class="{active: previousLeisureFrequencyCar == number}" v-for="number in [0, 1, 2, 3, 4, 5, 6, 7]" :key="number" @click="selectFrequency('previousLeisureFrequencyCar', number)">{{ number }}</div>
					</div>
					<div class="survey-frequency-chips-helpers right">
						<div>dagar per vecka</div>
					</div>
				</div>
				<div class="survey-frequency-chips">
					<h3 :class="{surveyError: errors.includes('previousLeisureFrequencyCarCoride')}">🚙 Bil - samåkning med annan</h3>
					<div class="survey-frequency-chips-container">
						<div class="survey-frequency-chips-container-chip car" :class="{active: previousLeisureFrequencyCarCoride == number}" v-for="number in [0, 1, 2, 3, 4, 5, 6, 7]" :key="number" @click="selectFrequency('previousLeisureFrequencyCarCoride', number)">{{ number }}</div>
					</div>
					<div class="survey-frequency-chips-helpers right">
						<div>dagar per vecka</div>
					</div>
				</div>
				<div class="survey-frequency-chips">
					<h3 :class="{surveyError: errors.includes('previousLeisureFrequencyMisc')}">Övrigt</h3>
					<div class="survey-frequency-chips-container">
						<div class="survey-frequency-chips-container-chip" :class="{active: previousLeisureFrequencyMisc == number}" v-for="number in [0, 1, 2, 3, 4, 5, 6, 7]" :key="number" @click="selectFrequency('previousLeisureFrequencyMisc', number)">{{ number }}</div>
					</div>
					<div class="survey-frequency-chips-helpers right">
						<div>dagar per vecka</div>
					</div>
				</div>

				<template v-if="previousLeisureFrequencyWalk || previousLeisureFrequencyBike || previousLeisureFrequencyTransit || previousLeisureFrequencyCar || previousLeisureFrequencyCarCoride || previousLeisureFrequencyMisc">
					<h4 class="mt-2 mb-1">Hur många gånger per vecka färdas du, i genomsnitt, för <span style="color: #00A9CE;">dina fritidsresor</span>?</h4>
					<p class="mb-2"><em class="smaller-em">(Tur och retur räknas alltså som en gång. Räkna INTE med när du färdas till någon annan plats på väg till eller från jobbet – det ingår på förra sidan.)</em></p>

					<div class="survey-thirds mt-3">
						<div class="survey-thirds-first" :class="{surveyError: errors.includes('previousLeisureNumberOfTrips')}">Antal resor:</div>

						<div class="survey-thirds-middle">
							<vue-slider dotSize="20" :max="35" v-model="previousLeisureNumberOfTrips"></vue-slider>
						</div>

						<div class="survey-thirds-last"><v-text-field hide-details v-model.number="previousLeisureNumberOfTrips"></v-text-field> resor</div>
					</div>


					<h4 class="mt-6 mb-6">Hur långt färdas du med följande färdsätt, i genomsnitt, för <span style="color: #00A9CE;">dina fritidsresor</span>?</h4>
					<p class="mb-2"><em class="smaller-em">(Räkna med både vägen till destinationen och vägen tillbaka.)</em></p>

					<div class="survey-thirds walking mt-3">
						<div class="survey-thirds-first-alt" :class="{surveyError: errors.includes('previousLeisureWeeklyWalking')}">Till fots</div>
						<div class="survey-thirds-middle"><vue-slider :max="200" v-model="previousLeisureWeeklyWalking"><template v-slot:dot><div class="custom-dot alt">🚶</div></template></vue-slider></div>
						<div class="survey-thirds-last"><v-text-field hide-details v-model.number="previousLeisureWeeklyWalking"></v-text-field> km</div>
					</div>

					<div class="survey-thirds bike mt-3">
						<div class="survey-thirds-first-alt" :class="{surveyError: errors.includes('previousLeisureWeeklyBike')}">Cykel</div>
						<div class="survey-thirds-middle"><vue-slider :max="200" v-model="previousLeisureWeeklyBike"><template v-slot:dot><div class="custom-dot alt">🚲</div></template></vue-slider></div>
						<div class="survey-thirds-last"><v-text-field hide-details v-model.number="previousLeisureWeeklyBike"></v-text-field> km</div>
					</div>

					<div class="survey-thirds transit mt-3">
						<div class="survey-thirds-first-alt" :class="{surveyError: errors.includes('previousLeisureWeeklyTransit')}">Kollektivt</div>
						<div class="survey-thirds-middle"><vue-slider :max="1000" v-model="previousLeisureWeeklyTransit"><template v-slot:dot><div class="custom-dot alt">🚌</div></template></vue-slider></div>
						<div class="survey-thirds-last"><v-text-field hide-details v-model.number="previousLeisureWeeklyTransit"></v-text-field> km</div>
					</div>

					<div class="survey-thirds car mt-3">
						<div class="survey-thirds-first-alt" :class="{surveyError: errors.includes('previousLeisureWeeklyCar')}">Bil - själv/med hushållsmedlem</div>
						<div class="survey-thirds-middle"><vue-slider :max="1000" v-model="previousLeisureWeeklyCar"><template v-slot:dot><div class="custom-dot alt">🚗</div></template></vue-slider></div>
						<div class="survey-thirds-last"><v-text-field hide-details v-model.number="previousLeisureWeeklyCar"></v-text-field> km</div>
					</div>

					<div class="survey-thirds carCoride mt-3">
						<div class="survey-thirds-first-alt" :class="{surveyError: errors.includes('previousLeisureWeeklyCarCoride')}">Bil - samåkning med annan</div>
						<div class="survey-thirds-middle"><vue-slider :max="1000" v-model="previousLeisureWeeklyCarCoride"><template v-slot:dot><div class="custom-dot alt">🚙</div></template></vue-slider></div>
						<div class="survey-thirds-last"><v-text-field hide-details v-model.number="previousLeisureWeeklyCarCoride"></v-text-field> km</div>
					</div>

					<div class="survey-thirds misc mt-3">
						<div class="survey-thirds-first-alt" :class="{surveyError: errors.includes('previousLeisureWeeklyMisc')}">
							<v-tooltip bottom>
						      <template v-slot:activator="{ on, attrs }"><span v-bind="attrs" v-on="on">Övrigt <div class="tooltip-container"><span class="icon-info"></span></div></span></template>
						      <span>t.ex. elsparkcykel, skateboard etc."</span>
						    </v-tooltip>
						</div>
						<div class="survey-thirds-middle"><vue-slider dotSize="20" :max="200" v-model="previousLeisureWeeklyMisc"></vue-slider></div>
						<div class="survey-thirds-last"><v-text-field hide-details v-model.number="previousLeisureWeeklyMisc"></v-text-field> km</div>
					</div>

					<div class="survey-thirds-sum"><strong>SUMMA</strong> <span>{{ previousLeisureWeeklySum }} km</span></div>

					<div class="survey-sum mt-6"><strong>Din genomsnittliga <span style="color: #00A9CE;">fritidsresa</span> är {{ previousLeisureComputedWeeklyAverage }} km</strong> och du färdas <strong>{{ previousLeisureWeeklySum }} km per vecka</strong>, vilket blir <strong>{{ previousLeisureYearlyDistance }} km utslaget på ett år</strong> (ifall du färdas likadant alla veckor om året).
						<br/>
						<br/>
						<em>Om reslängden per vecka verkar rimlig, vänligen gå vidare i enkäten. Om inte, justera i frågorna ovan.</em></div>


					<div v-if="previousLeisureWeeklyCar">
						<h4 class="mt-5">Hur är dina bilresor fördelade utifrån drivmedel?</h4>
						<p class="mb-2"><em class="smaller-em">(Summan för de olika drivmedlen måste matcha med Bil - själv/med hushållsmedlem ovan ({{ previousLeisureWeeklyCar }} km))</em></p>

						<div class="survey-thirds electricity mt-3">
							<div class="survey-thirds-first-alt" :class="{surveyError: errors.includes('previousLeisureWeeklyElectricity')}">El</div>
							<div class="survey-thirds-middle"><vue-slider dotSize="20" :max="1000" v-model="previousLeisureWeeklyElectricity"></vue-slider></div>
							<div class="survey-thirds-last"><v-text-field hide-details v-model.number="previousLeisureWeeklyElectricity"></v-text-field> km</div>
						</div>

						<div class="survey-thirds hybrid mt-3">
							<div class="survey-thirds-first-alt" :class="{surveyError: errors.includes('previousLeisureWeeklyHybrid')}">Hybrid/gas</div>
							<div class="survey-thirds-middle"><vue-slider dotSize="20" :max="1000" v-model="previousLeisureWeeklyHybrid"></vue-slider></div>
							<div class="survey-thirds-last"><v-text-field hide-details v-model.number="previousLeisureWeeklyHybrid"></v-text-field> km</div>
						</div>

						<div class="survey-thirds gas mt-3">
							<div class="survey-thirds-first-alt" :class="{surveyError: errors.includes('previousLeisureWeeklyGas')}">Bensin/diesel<br/>/etanol</div>
							<div class="survey-thirds-middle"><vue-slider dotSize="20" :max="1000" v-model="previousLeisureWeeklyGas"></vue-slider></div>
							<div class="survey-thirds-last"><v-text-field hide-details v-model.number="previousLeisureWeeklyGas"></v-text-field> km</div>
						</div>
					</div>
				</template>

				<div class="nudgd-btn inline survey-submit mt-10" @click="nextStep()">Gå vidare</div>
				<div class="nudgd-btn small survey-submit mt-10" @click="prevStep()">Tillbaka</div>
				<div style="clear:both;"></div>
			</div>

<!-- Page 3: SMART NUDGES MOBILITY USE 					-->

			<div v-if="stepIndex === 2">

        <img
          style="float: right;"
          width="300"
          :src="$apiUrl + '/storage/google-pixel-2-xl-resvana-20-1280x720-umea-1625230507wJMF2.png'"
          alt="Tjänsten Resvana"
        />

				<div class="mt-2 mb-4" :class="{surveyError: errors.includes('usedResvana')}"><strong>Du fick för ett tag sen en länk till en tjänst kallad Resvana.</strong> Den innehåller bland annat info om olika hållbara transportalternativ nära dig och tips om att starta nya resvanor. <strong>Läste du något där inne eller använde kartan etc.?</strong></div>

				<div class="survey-radio-row mb-6">
					<v-radio-group class="mt-0" v-model="usedResvana" row>
						<v-radio label="Ja" value="Ja"></v-radio>
						<v-radio label="Nej" value="Nej"></v-radio>
					</v-radio-group>
				</div>

				<div v-if="usedResvana === 'Ja'">
					<h2>Tjänsten Resvana</h2>
					<h4 class="mt-4" :class="{surveyError: errors.includes('resvanaEffect')}">I vilken utsträckning skulle du säga att Resvana har bidragit till ditt val av färdmedel?</h4>
					<em class="smaller-em">(0 = Inte alls; 10 = Helt och hållet)</em>
					<vue-slider marks class="mt-3" :max="10" v-model="resvanaEffect"></vue-slider>


					<h4 class="mt-10 mb-4">Tjänsten har fått mig att börja...</h4>

					<div class="survey-radio-row">
						<div class="survey-radio-row-first" :class="{surveyError: errors.includes('moreWalking')}">...promenerera (eller åka rullstol) mer</div>
						<v-radio-group class="mt-0" v-model="more.walking" row>
									<v-radio label="Ja" value="Ja"></v-radio>
									<v-radio label="Nja, men har fått mig att planera att göra det" value="Nja, men har fått mig att planera att göra det"></v-radio>
									<v-radio label="Nej" value="Nej"></v-radio>
							</v-radio-group>
						</div>

						<div class="survey-radio-row">
							<div class="survey-radio-row-first" :class="{surveyError: errors.includes('moreBiking')}">...cykla mer</div>
						<v-radio-group v-model="more.biking" row>
									<v-radio label="Ja" value="Ja"></v-radio>
									<v-radio label="Nja, men har fått mig att planera att göra det" value="Nja, men har fått mig att planera att göra det"></v-radio>
									<v-radio label="Nej" value="Nej"></v-radio>
							</v-radio-group>
						</div>

						<div class="survey-radio-row">
							<div class="survey-radio-row-first" :class="{surveyError: errors.includes('moreTransit')}">...åka mer kollektivtrafik (av någon typ)</div>
						<v-radio-group v-model="more.transit" row>
									<v-radio label="Ja" value="Ja"></v-radio>
									<v-radio label="Nja, men har fått mig att planera att göra det" value="Nja, men har fått mig att planera att göra det"></v-radio>
									<v-radio label="Nej" value="Nej"></v-radio>
							</v-radio-group>
						</div>

						<div class="survey-radio-row">
						<div class="survey-radio-row-first" :class="{surveyError: errors.includes('moreCar')}">...åka bil på ett mer hållbart sätt, t.ex. elbil, samåkning, bilpool, etc.</div>
						<v-radio-group v-model="more.car" row>
									<v-radio label="Ja" value="Ja"></v-radio>
									<v-radio label="Nja, men har fått mig att planera att göra det" value="Nja, men har fått mig att planera att göra det"></v-radio>
									<v-radio label="Nej" value="Nej"></v-radio>
							</v-radio-group>
						</div>

					<h4 class="mb-3 mt-6" :class="{surveyError: errors.includes('resvanaRecommend')}">Hur troligt är det att du skulle rekommendera Resvana till en kollega eller vän?</h4>
					<vue-slider marks class="pb-10" :max="10" v-model="resvanaRecommend"></vue-slider>
				</div>

				<h4 class="mb-3 mt-10">Kommentar <span style="font-weight:normal;">(ej obligatorisk)</span></h4>
				<v-textarea rows="4" hide-details solo v-model="commentary"></v-textarea>
				<div class="survey-help mt-2">(Vänligen lämna inga personuppgifter i detta fält)</div>

				<h4 class="mt-2 mb-3" :class="{surveyError: errors.includes('usedResvana')}">Vi vill arbeta ihop med dig i vårt arbete med att göra samhällets resande hållbart. Får vi därför framöver be dig om råd och rekommendationer och fråga mer om dina resvanor? Stort tack på förhand! Ange i så fall din epost nedan.</h4>
				<p style="font-size:13px;">Läs mer om <a style="font-weight: 600; text-decoration: none;" href="https://nudgd.se/om-nudgd/integritetspolicy/" target="_blank">hur vi hanterar personuppgifter</a></p>

				<v-text-field dense hide-details placeholder="E-post" v-model="contactMe" outlined></v-text-field>

				<div class="nudgd-btn inline survey-submit mt-10" @click="nextStep()">Gå vidare</div>
				<div class="nudgd-btn small survey-submit mt-10" @click="prevStep()">Tillbaka</div>
				<div style="clear:both;"></div>
			</div>

<!-- Page 4: OPPORTUNITY / CAPABILITY					-->

			<div v-if="stepIndex === 3">
				<h4 class="mt-0 mb-2" :class="{surveyError: errors.includes('currentLevelOfCar')}">Vilket av följande påståenden beskriver bäst hur du känner för din nuvarande bilanvändning i ditt vardagsresande och om du har några planer på att försöka minska några eller alla av dessa bilresor?</h4>
				<p class="mb-2"><em class="smaller-em">(Tänk både på att färdas till och från jobbet och på hur du färdas på fritiden.)</em></p>
				<v-radio-group class="mt-3 v-radio-group-small" v-model="currentLevelOfCar" row>
					<v-radio label="Jag använder bilen för de flesta av mina resor. Jag är nöjd med detta och ser ingen anledning att minska min bilanvändning." value="Jag använder bilen för de flesta av mina resor. Jag är nöjd med detta och ser ingen anledning att minska min bilanvändning."></v-radio>
					<v-radio label="Jag använder bilen för de flesta av mina resor. Jag vill minska min bilanvändning men det känns för närvarande inte möjligt." value="Jag använder bilen för de flesta av mina resor. Jag vill minska min bilanvändning men det känns för närvarande inte möjligt."></v-radio>
					<v-radio label="Jag använder bilen för de flesta av mina resor. Jag funderar just nu på att ändra några eller alla av dessa resor till annat transportsätt men är osäker på hur eller när jag ska göra det." value="Jag använder bilen för de flesta av mina resor. Jag funderar just nu på att ändra några eller alla av dessa resor till annat transportsätt men är osäker på hur eller när jag ska göra det."></v-radio>
					<v-radio label="Jag använder bilen för de flesta av mina resor, men mitt mål är att minska min bilanvändning. Jag vet redan vilka resor jag kommer att ersätta och vilket transportsätt jag kommer att använda, men har ännu inte omsatt detta i praktiken." value="Jag använder bilen för de flesta av mina resor, men mitt mål är att minska min bilanvändning. Jag vet redan vilka resor jag kommer att ersätta och vilket transportsätt jag kommer att använda, men har ännu inte omsatt detta i praktiken."></v-radio>
					<v-radio label="Eftersom jag inte äger/har tillgång till en bil är det för närvarande inte ett problem för mig att minska min bilanvändning." value="Eftersom jag inte äger/har tillgång till en bil är det för närvarande inte ett problem för mig att minska min bilanvändning."></v-radio>
					<v-radio label="Eftersom jag är medveten om de många problem som är förknippade med bilanvändning, försöker jag redan använda andra transportsätt så mycket som möjligt. Jag kommer att behålla eller till och med minska min redan låga nivå av bilanvändning under de kommande månaderna." value="Eftersom jag är medveten om de många problem som är förknippade med bilanvändning, försöker jag redan använda andra transportsätt så mycket som möjligt. Jag kommer att behålla eller till och med minska min redan låga nivå av bilanvändning under de kommande månaderna."></v-radio>
				</v-radio-group>


				<h4 class="mb-2" :class="{surveyError: errors.includes('iHaveAccessTo')}">Jag har eller har tillgång till</h4>
				<v-chip-group active-class="primary--text" column multiple v-model="iHaveAccessTo">
				    <v-chip :disabled="currentLevelOfCar === 'Eftersom jag inte äger/har tillgång till en bil är det för närvarande inte ett problem för mig att minska min bilanvändning.'" value="Bil" outlined>Bil</v-chip>
					<v-chip :disabled="currentLevelOfCar === 'Eftersom jag inte äger/har tillgång till en bil är det för närvarande inte ett problem för mig att minska min bilanvändning.'" value="Bilpool" outlined>Bilpool</v-chip>
				    <v-chip value="Prisvärd parkering nära jobbet" outlined>Prisvärd parkering nära jobbet</v-chip>
						<v-chip value="Körkort" outlined>Körkort</v-chip>
				    <v-chip value="Bra kollektivtrafik" outlined>Bra kollektivtrafik</v-chip>
				    <v-chip value="Kollektivtrafikskort" outlined>Kollektivtrafikskort</v-chip>
						<v-chip value="Cykel" outlined>Cykel</v-chip>
				    <v-chip value="Cykelpool" outlined>Cykelpool</v-chip>
						<v-chip value="Inget av dessa" outlined>Inget av dessa</v-chip>
				</v-chip-group>


				<h4 class="mt-6 mb-2" :class="{surveyError: errors.includes('obstaclesToSustainability')}">Följande upplever jag som hinder för att färdas mer hållbart</h4>
				<p class="mb-2"><em class="smaller-em">(Ange de 2 som är störst hinder för dig. Tänk både på att färdas till och från jobbet och på hur du färdas på fritiden.)</em></p>
				<v-chip-group active-class="primary--text" column multiple v-model="obstaclesToSustainability" max="2">
				    <v-chip value="Tar för lång tid" outlined>Tar för lång tid</v-chip>
				    <v-chip value="Lämna familjemedlem på vägen" outlined>Lämna familjemedlem på vägen</v-chip>
				    <v-chip value="Tillgänglighet till bra kollektivtrafik" outlined>Tillgänglighet till bra kollektivtrafik</v-chip>
				    <v-chip value="Avstånd till arbetet" outlined>Avstånd till arbetet</v-chip>
				    <v-chip value="Obekvämt/för jobbigt" outlined>Obekvämt/för jobbigt</v-chip>
						<v-chip value="Säkerhet" outlined>Säkerhet</v-chip>
				    <v-chip value="Fysiskt hinder" outlined>Fysiskt hinder</v-chip>
						<v-chip value="Annat" outlined>Annat</v-chip>
				</v-chip-group>

				<h4 class="mt-5 mb-2">Kommentar</h4>
				<v-textarea class="mt-4" rows="4" hide-details solo v-model="obstaclesToSustainabilityComment" placeholder="Lägg gärna till något om vad som har gjort att du i vardagen färdas så som du för närvarande gör, och varför – vi vill höra vad du tycker!"></v-textarea>




				<div class="nudgd-btn inline survey-submit mt-10" @click="nextStep()">Gå vidare</div>
				<div class="nudgd-btn small survey-submit mt-10" @click="prevStep()">Tillbaka</div>
				<div style="clear:both;"></div>
			</div>

<!-- Page 5: MOTIVATION					-->

			<div v-if="stepIndex === 4">
				<h4 class="mb-3" :class="{surveyError: errors.includes('subjectiveSustainability')}">Jag anser att jag i dagsläget färdas hållbart i min vardag</h4>
				<p class="mb-2"><em class="smaller-em">Tänk både på att färdas till och från jobbet och på hur du färdas på fritiden.</em></p>
				<div class="survey-frequency-chips">
					<div class="survey-frequency-chips-container">
						<div class="survey-frequency-chips-container-chip bike" :class="{active: subjectiveSustainability == number}" v-for="number in [1, 2, 3, 4, 5]" :key="number" @click="selectFrequency('subjectiveSustainability', number)">
							{{ number }}
						</div>
					</div>

					<div class="survey-frequency-chips-helpers">
						<div>Nej,<br class="d-md-none"> inte alls</div>
						<div class="text-right">Ja,<br class="d-md-none"> fullt ut</div>
					</div>
				</div>



				<h4 class="mt-6 mb-1" :class="{surveyError: errors.includes('sustainabilityWish')}">Jag önskar att jag kunde färdas mer hållbart i min vardag</h4>
				<p class="mb-2"><em class="smaller-em">Tänk både på att färdas till och från jobbet och på hur du färdas på fritiden.</em></p>
				<div class="survey-frequency-chips" v-if=" ! alwaysWalkAndBike">
					<div class="survey-frequency-chips-container">
						<div class="survey-frequency-chips-container-chip bike" :class="{active: sustainabilityWish == number}" v-for="number in [1, 2, 3, 4, 5]" :key="number" @click="selectFrequency('sustainabilityWish', number)">
							{{ number }}
						</div>
					</div>

					<div class="survey-frequency-chips-helpers">
						<div>Nej,<br class="d-md-none"> inte alls</div>
						<div class="text-right">Ja,<br class="d-md-none"> väldigt mycket</div>
					</div>
				</div>
				<v-checkbox class="mb-5" hide-details v-model="alwaysWalkAndBike" value="Jag går/cyklar alltid och kan därför inte resa mer hållbart" label="Jag går/cyklar alltid och kan därför inte resa mer hållbart"></v-checkbox>


				<h4 class="mt-6 mb-2">Hur känner du inför att det närmaste året öka din användning av följande färdsätt i ditt vardagsresande?</h4>
				<p class="mb-2"><em class="smaller-em">Tänk både på att färdas till och från jobbet och på hur du färdas på fritiden.</em></p>

				<div class="survey-frequency-chips">
					<h3 :class="{surveyError: errors.includes('wishedIncreaseModeOfTransportWalk')}">🚶 Till fots</h3>
					<div class="survey-frequency-chips-container">
						<div class="survey-frequency-chips-container-chip walking" :class="{active: wishedIncreaseModeOfTransportWalk == number}" v-for="number in [1, 2, 3, 4, 5]" :key="number" @click="selectFrequency('wishedIncreaseModeOfTransportWalk', number)">{{ number }}</div>
					</div>
					<div class="survey-frequency-chips-helpers">
						<div>Definitivt<br class="d-md-none"> inte</div>
						<div class="text-right">Jättepositiv,<br class="d-md-none"> ska göra det</div>
					</div>
				</div>
				<div class="survey-frequency-chips mt-7">
					<h3 :class="{surveyError: errors.includes('wishedIncreaseModeOfTransportBike')}">🚲 Cykel</h3>
					<div class="survey-frequency-chips-container">
						<div class="survey-frequency-chips-container-chip bike" :class="{active: wishedIncreaseModeOfTransportBike == number}" v-for="number in [1, 2, 3, 4, 5]" :key="number" @click="selectFrequency('wishedIncreaseModeOfTransportBike', number)">{{ number }}</div>
					</div>
					<div class="survey-frequency-chips-helpers">
						<div>Definitivt<br class="d-md-none"> inte</div>
						<div class="text-right">Jättepositiv,<br class="d-md-none"> ska göra det</div>
					</div>
				</div>
				<div class="survey-frequency-chips mt-7">
					<h3 :class="{surveyError: errors.includes('wishedIncreaseModeOfTransportTransit')}">🚌 Kollektivtrafik</h3>
					<div class="survey-frequency-chips-container">
						<div class="survey-frequency-chips-container-chip transit" :class="{active: wishedIncreaseModeOfTransportTransit == number}" v-for="number in [1, 2, 3, 4, 5]" :key="number" @click="selectFrequency('wishedIncreaseModeOfTransportTransit', number)">{{ number }}</div>
					</div>
					<div class="survey-frequency-chips-helpers">
						<div>Definitivt<br class="d-md-none"> inte</div>
						<div class="text-right">Jättepositiv,<br class="d-md-none"> ska göra det</div>
					</div>
				</div>
				<div class="survey-frequency-chips mt-7">
					<h3 :class="{surveyError: errors.includes('wishedIncreaseModeOfTransportCar')}">🚗 Bensin-/diesel-/etanolbil (själv eller med familjemedlem)</h3>
					<div class="survey-frequency-chips-container">
						<div class="survey-frequency-chips-container-chip car" :class="{active: wishedIncreaseModeOfTransportCar == number}" v-for="number in [1, 2, 3, 4, 5]" :key="number" @click="selectFrequency('wishedIncreaseModeOfTransportCar', number)">{{ number }}</div>
					</div>
					<div class="survey-frequency-chips-helpers">
						<div>Definitivt<br class="d-md-none"> inte</div>
						<div class="text-right">Jättepositiv,<br class="d-md-none"> ska göra det</div>
					</div>
				</div>
				<div class="survey-frequency-chips mt-7">
					<h3 :class="{surveyError: errors.includes('wishedIncreaseModeOfTransportCarSustainable')}">🚗 El-/biogas-/väte-/hybridbil (själv eller med familjemedlem)</h3>
					<div class="survey-frequency-chips-container">
						<div class="survey-frequency-chips-container-chip car" :class="{active: wishedIncreaseModeOfTransportCarSustainable == number}" v-for="number in [1, 2, 3, 4, 5]" :key="number" @click="selectFrequency('wishedIncreaseModeOfTransportCarSustainable', number)">{{ number }}</div>
					</div>
					<div class="survey-frequency-chips-helpers">
						<div>Definitivt<br class="d-md-none"> inte</div>
						<div class="text-right">Jättepositiv,<br class="d-md-none"> ska göra det</div>
					</div>
				</div>
				<div class="survey-frequency-chips mt-7">
					<h3 :class="{surveyError: errors.includes('wishedIncreaseModeOfTransportCoride')}">🚙 Samåkning</h3>
					<div class="survey-frequency-chips-container">
						<div class="survey-frequency-chips-container-chip car" :class="{active: wishedIncreaseModeOfTransportCoride == number}" v-for="number in [1, 2, 3, 4, 5]" :key="number" @click="selectFrequency('wishedIncreaseModeOfTransportCoride', number)">{{ number }}</div>
					</div>
					<div class="survey-frequency-chips-helpers">
						<div>Definitivt<br class="d-md-none"> inte</div>
						<div class="text-right">Jättepositiv,<br class="d-md-none"> ska göra det</div>
					</div>
				</div>


				<h4 class="mt-6 mb-2" :class="{surveyError: errors.includes('mostImportantForMe')}">I mitt val av färdsätt är detta det som är viktigast för mig</h4>
				<v-chip-group active-class="primary--text" column multiple v-model="mostImportantForMe" max="2">
				    <v-chip value="Miljö" outlined>Miljö</v-chip>
				    <v-chip value="Hälsa" outlined>Hälsa</v-chip>
				    <v-chip value="Tid" outlined>Tid</v-chip>
				    <v-chip value="Kostnad" outlined>Kostnad</v-chip>
				    <v-chip value="Bekvämlighet" outlined>Bekvämlighet</v-chip>
						<v-chip value="Att resa så som mina kollegor/vänner gör" outlined>Att resa så som mina kollegor/vänner gör</v-chip>
						<v-chip value="Säkerhet" outlined>Säkerhet</v-chip>
				</v-chip-group>

				<h4 class="mt-5 mb-2">Kommentar</h4>
				<v-textarea class="mt-4" rows="4" hide-details solo v-model="mostImportantForMeComment" placeholder="Lägg gärna till något om vad som påverkar hur du tänker färdas i vardagen framöver, och varför – vi vill höra vad du tycker!"></v-textarea>


				<template v-if="hasCompletedPrevious">
					<div class="nudgd-btn inline survey-submit mt-10" v-if=" ! thankYou" @click="submitResponse()">Skicka in</div>
				</template>

				<template v-if=" ! hasCompletedPrevious">
					<div class="nudgd-btn inline survey-submit mt-10" @click="nextStep()">Gå vidare</div>
				</template>

				<div class="nudgd-btn small survey-submit mt-10" @click="prevStep()">Tillbaka</div>
				<div style="clear:both;"></div>
			</div>

<!-- Page 6: DEMOGRPHICS					-->

			<div v-if="stepIndex === 5">
				<template v-if=" ! hasCompletedPrevious">
					<h4 class="mb-2" :class="{surveyError: errors.includes('gender')}">Kön</h4>
					<v-chip-group active-class="primary--text" column v-model="gender">
					    <v-chip value="Man" outlined>Man</v-chip>
					    <v-chip value="Kvinna" outlined>Kvinna</v-chip>
					    <v-chip value="Annat/Vill ej ange" outlined>Annat/Vill ej ange</v-chip>
					</v-chip-group>


					<h4 class="mb-2" :class="{surveyError: errors.includes('birthYear')}">Födelseår (YYYY)</h4>
					<v-text-field dense v-model="birthYear" outlined hide-details></v-text-field>


					<h4 class="mb-2" :class="{surveyError: errors.includes('peopleInHousehold')}">Antal personer i hushållet</h4>
					<v-chip-group active-class="primary--text" column v-model="peopleInHousehold">
					    <v-chip value="1" outlined>1</v-chip>
					    <v-chip value="2" outlined>2</v-chip>
					    <v-chip value="3" outlined>3</v-chip>
					    <v-chip value="4" outlined>4</v-chip>
					    <v-chip value="5" outlined>5</v-chip>
					    <v-chip value="5+" outlined>5+</v-chip>
					</v-chip-group>


					<h4 class="mb-2" :class="{surveyError: errors.includes('noOfChildren')}">Barn</h4>
					<v-chip-group active-class="primary--text" column v-model="noOfChildren">
						<v-chip value="Ja, upp till 12 år" outlined>Ja, upp till 12 år</v-chip>
						<v-chip value="Ja, tonåring(ar)" outlined>Ja, tonåring(ar)</v-chip>
					    <v-chip value="Ja, både upp till 12 år och tonåring(ar)" outlined>Ja, både upp till 12 år och tonåring(ar)</v-chip>
					    <v-chip value="Inga barn i hushållet" outlined>Inga barn i hushållet</v-chip>
					</v-chip-group>

					<h4 class="mb-2" :class="{surveyError: errors.includes('employment')}">Sysselsättning</h4>
					<v-chip-group active-class="primary--text" column v-model="employment">
					    <v-chip value="Arbetar" outlined>Arbetar</v-chip>
					    <v-chip value="Studerar" outlined>Studerar</v-chip>
							<v-chip value="Pensionär" outlined>Pensionär</v-chip>
					    <v-chip value="Annat" outlined>Annat</v-chip>
					</v-chip-group>


					<h4 class="mb-2" :class="{surveyError: errors.includes('distanceEmployment')}">Distansarbete</h4>
					<p class="mb-2"><em class="smaller-em">I hur stor grad arbetar du på distans, t.ex. hemifrån?</em></p>
					<v-chip-group active-class="primary--text" column v-model="distanceEmployment">
					    <v-chip value="0%" outlined>0%</v-chip>
							<v-chip value="20%" outlined>20%</v-chip>
							<v-chip value="40%" outlined>40%</v-chip>
					    <v-chip value="60%" outlined>60%</v-chip>
					    <v-chip value="80%" outlined>80%</v-chip>
					    <v-chip value="100%" outlined>100%</v-chip>
					</v-chip-group>


					<h4 class="mb-2" :class="{surveyError: errors.includes('educationAttainment')}">Utbildningsnivå</h4>
					<p class="mb-2"><em class="smaller-em">(Markera det högsta alternativet)</em></p>
					<v-chip-group active-class="primary--text" column v-model="educationAttainment">
					    <v-chip value="Grundskola" outlined>Grundskola</v-chip>
					    <v-chip value="Gymnasie" outlined>Gymnasie</v-chip>
					    <v-chip value="Högskola" outlined>Högskola</v-chip>
					</v-chip-group>


					<h4 class="mb-2" :class="{surveyError: errors.includes('housingType')}">Bostadstyp</h4>
					<v-chip-group active-class="primary--text" column v-model="housingType">
					    <v-chip value="Hyresrätt" outlined>Hyresrätt</v-chip>
					    <v-chip value="Bostadsrätt" outlined>Bostadsrätt</v-chip>
					    <v-chip value="Villa" outlined>Villa</v-chip>
					    <v-chip value="Annat" outlined>Annat</v-chip>
					</v-chip-group>


					<h4 class="mb-2" :class="{surveyError: errors.includes('income')}">Ungefär hur stor är ditt hushålls totala inkomst före skatt en vanlig månad?</h4>
					<p class="mb-2"><em class="smaller-em">(Räkna med eventuella bidrag, t.ex. barnbidrag, bostadsbidrag, studiebidrag m.m.)</em></p>
					<v-chip-group active-class="primary--text" column v-model="income">
					    <v-chip value="Under 20 000" outlined>Under 20 000</v-chip>
					    <v-chip value="20 000 - 29 999" outlined>20 000 - 29 999</v-chip>
					    <v-chip value="30 000 - 39 999" outlined>30 000 - 39 999</v-chip>
					    <v-chip value="40 000 - 49 999" outlined>40 000 - 49 999</v-chip>
					    <v-chip value="50 000 - 59 999" outlined>50 000 - 59 999</v-chip>
					    <v-chip value="60 000 - 69 999" outlined>60 000 - 69 999</v-chip>
					    <v-chip value="70 000 - 79 999" outlined>70 000 - 79 999</v-chip>
					    <v-chip value="80 000 - 89 999" outlined>80 000 - 89 999</v-chip>
					    <v-chip value="90 000 - 99 999" outlined>90 000 - 99 999</v-chip>
					    <v-chip value="Över 100 000" outlined>Över 100 000</v-chip>
						  <v-chip value="Vill inte ange" outlined>Vill inte ange</v-chip>
					</v-chip-group>
				</template>

				<div class="nudgd-btn inline survey-submit mt-10" v-if=" ! thankYou" @click="submitResponse()">Skicka in</div>
				<div class="nudgd-btn small survey-submit mt-10" v-if=" ! thankYou" @click="prevStep()">Tillbaka</div>
				<div style="clear:both;"></div>
			</div>

			<v-progress-linear color="#00A19A" height="10" rounded class="mt-8" :value="(stepIndex + 1) / (hasCompletedPrevious ? 5 : 6) * 100"></v-progress-linear>
		</div>

		    <v-dialog
		    	v-model="thankYou"
		    	width="'100%'"
		    	max-width="900"
		    	scrollable
		    	class="dialog"
		    	persistent
		    >

				<v-card>
					<v-card-title class="card-dialog-title" style="font-weight:700;">
						<div>Tack för att du svarat!</div>
					</v-card-title>

					<v-card-text>
						<p>Du är en viktig del i att skapa ännu bättre förutsättningar för smart vardagsresande åt dig och oss alla.</p>
						<p>Gå gärna till tjänsten Resvana igen för att inspireras till mer hållbart resande.</p>

						<p><a class="nudgd-btn inline survey-submit mt-5" :href="$processText('https://app.resvana.com/{slug}')">Till tjänsten</a></p>
					</v-card-text>
				</v-card>

		    </v-dialog>
	</div>
</template>

<script>
import axios from 'axios'
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'
import ModeOfTransport from '@/components/ModeOfTransport.vue'

export default {
	components: {VueSlider, ModeOfTransport},

	mounted() {
		this.uuid = Math.random().toString(36).substr(2, 5)
		this.$store.state.surveyId = 8

		// For testing purposes
		if (this.$route.query.page) {
			this.stepIndex = parseInt(this.$route.query.page)
		}

		// Get end user
		axios.get(this.$apiUrl + '/api/end-user/' + this.$route.params.slug).then(res => {
			this.$store.state.endUser = res.data.endUser
			this.$store.state.translations = res.data.translations
		})
	},

	data() {
		return {
			steps: 5,
			previousFrequencyCar: null,
			previousFrequencyCarCoride: null,
			previousFrequencyBike: null,
			previousFrequencyWalk: null,
			previousFrequencyTransit: null,
			previousFrequencyMisc: null,
			previousMainModeOfTransport: null,

			previousWeeklyWalking: 0,
			previousWeeklyBike: 0,
			previousWeeklyTransit: 0,
			previousWeeklyCar: 0,
			previousWeeklyCarCoride: 0,
			previousWeeklyMisc: 0,

			previousWeeklyElectricity: 0,
			previousWeeklyHybrid: 0,
			previousWeeklyGas: 0,

			previousNumberOfTrips: null,

			previousLeisureMainModeOfTransport: null,
			previousLeisureNumberOfTrips: 0,
			previousLeisureFrequencyWalk: null,
			previousLeisureFrequencyBike: null,
			previousLeisureFrequencyTransit: null,
			previousLeisureFrequencyCar: null,
			previousLeisureFrequencyCarCoride: null,
			previousLeisureFrequencyMisc: null,

			previousLeisureWeeklyWalking: 0,
			previousLeisureWeeklyBike: 0,
			previousLeisureWeeklyTransit: 0,
			previousLeisureWeeklyCar: 0,
			previousLeisureWeeklyCarCoride: 0,
			previousLeisureWeeklyMisc: 0,

			previousLeisureWeeklyElectricity: 0,
			previousLeisureWeeklyHybrid: 0,
			previousLeisureWeeklyGas: 0,

			iHaveAccessTo: [],
			obstaclesToSustainability: [],
			currentLevelOfCar: null,

			subjectiveSustainability: null,
			sustainabilityWish: null,
			mostImportantForMe: [],
			alwaysWalkAndBike: null,

			obstaclesToSustainabilityComment: null,
			mostImportantForMeComment: null,

			income: null,
			housingType: null,
			educationAttainment: null,
			distanceEmployment: null,
			employment: null,
			noOfChildren: null,
			peopleInHousehold: null,
			birthYear: null,
			gender: null,

			wishedIncreaseModeOfTransportWalk: null,
			wishedIncreaseModeOfTransportBike: null,
			wishedIncreaseModeOfTransportTransit: null,
			wishedIncreaseModeOfTransportCar: null,
			wishedIncreaseModeOfTransportCarSustainable: null,
			wishedIncreaseModeOfTransportCoride: null,

			usedResvana: null,
			resvanaEffect: null,

			more: {
				walking: null,
				biking: null,
				transit: null,
				car: null
			},

			commentary: null,
			resvanaRecommend: null,
			contactMe: null,

			firstStepConfirmed: false,
			errors: [],
			engaged: [],
			stepIndex: 0,
			thankYou: false,

			// Each array represents the required fields of a step
			required: [
				[
					'previousMainModeOfTransport', 'previousFrequencyCar', 'previousFrequencyCarCoride',
					'previousFrequencyBike', 'previousFrequencyWalk', 'previousFrequencyTransit', 'previousFrequencyMisc',
				],
				[
					'previousLeisureMainModeOfTransport', 'previousLeisureFrequencyCar', 'previousLeisureFrequencyCarCoride',
					'previousLeisureFrequencyBike', 'previousLeisureFrequencyWalk', 'previousLeisureFrequencyTransit', 'previousLeisureFrequencyMisc',
				],
				[
					'usedResvana'
				],
				['iHaveAccessTo', 'obstaclesToSustainability', 'currentLevelOfCar'],
				[
					'subjectiveSustainability', 'sustainabilityWish', 'mostImportantForMe',
					'wishedIncreaseModeOfTransportWalk', 'wishedIncreaseModeOfTransportBike',
					'wishedIncreaseModeOfTransportTransit', 'wishedIncreaseModeOfTransportCar',
					'wishedIncreaseModeOfTransportCarSustainable', 'wishedIncreaseModeOfTransportCoride'
				],
				['income', 'housingType', 'educationAttainment', 'distanceEmployment', 'employment',
				'noOfChildren', 'peopleInHousehold', 'birthYear', 'gender']
			],
		}
	},

	// Each line represents the required fields of a step
	watch: {
		income(val) { this.engaged.push('income') },
		housingType(val) { this.engaged.push('housingType') },
		educationAttainment(val) { this.engaged.push('educationAttainment') },
		distanceEmployment(val) { this.engaged.push('distanceEmployment') },
		employment(val) { this.engaged.push('employment') },
		noOfChildren(val) { this.engaged.push('noOfChildren') },
		peopleInHousehold(val) { this.engaged.push('peopleInHousehold') },
		birthYear(val) { this.engaged.push('birthYear') },
		gender(val) { this.engaged.push('gender') },

		subjectiveSustainability(val) { this.engaged.push('subjectiveSustainability') },
		sustainabilityWish(val) { this.engaged.push('sustainabilityWish') },
		mostImportantForMe(val) { this.engaged.push('mostImportantForMe') },
		wishedIncreaseModeOfTransportWalk(val) { this.engaged.push('wishedIncreaseModeOfTransportWalk') },
		wishedIncreaseModeOfTransportBike(val) { this.engaged.push('wishedIncreaseModeOfTransportBike') },
		wishedIncreaseModeOfTransportTransit(val) { this.engaged.push('wishedIncreaseModeOfTransportTransit') },
		wishedIncreaseModeOfTransportCar(val) { this.engaged.push('wishedIncreaseModeOfTransportCar') },
		wishedIncreaseModeOfTransportCarSustainable(val) { this.engaged.push('wishedIncreaseModeOfTransportCarSustainable') },
		wishedIncreaseModeOfTransportCoride(val) { this.engaged.push('wishedIncreaseModeOfTransportCoride') },

		iHaveAccessTo(val) { this.engaged.push('iHaveAccessTo') },
		obstaclesToSustainability(val) { this.engaged.push('obstaclesToSustainability') },
		currentLevelOfCar(val) { this.engaged.push('currentLevelOfCar') },

		previousLeisureNumberOfTrips(val) { this.engaged.push('previousLeisureNumberOfTrips') },
		previousLeisureMainModeOfTransport(val) { this.engaged.push('previousLeisureMainModeOfTransport') },
		previousLeisureFrequencyCar(val) { this.engaged.push('previousLeisureFrequencyCar') },
		previousLeisureFrequencyCarCoride(val) { this.engaged.push('previousLeisureFrequencyCarCoride') },
		previousLeisureFrequencyBike(val) { this.engaged.push('previousLeisureFrequencyBike') },
		previousLeisureFrequencyWalk(val) { this.engaged.push('previousLeisureFrequencyWalk') },
		previousLeisureFrequencyTransit(val) { this.engaged.push('previousLeisureFrequencyTransit') },
		previousLeisureFrequencyMisc(val) { this.engaged.push('previousLeisureFrequencyMisc') },

		previousNumberOfTrips(val) { this.engaged.push('previousNumberOfTrips') },
		previousMainModeOfTransport(val) { this.engaged.push('previousMainModeOfTransport') },
		previousFrequencyCar(val) { this.engaged.push('previousFrequencyCar') },
		previousFrequencyCarCoride(val) { this.engaged.push('previousFrequencyCarCoride') },
		previousFrequencyBike(val) { this.engaged.push('previousFrequencyBike') },
		previousFrequencyWalk(val) { this.engaged.push('previousFrequencyWalk') },
		previousFrequencyTransit(val) { this.engaged.push('previousFrequencyTransit') },
		previousFrequencyMisc(val) { this.engaged.push('previousFrequencyMisc') },

		previousWeeklyCar(val) { this.engaged.push('previousWeeklyCar') },
		previousWeeklyWalking(val) { this.engaged.push('previousWeeklyWalking') },
		previousWeeklyBike(val) { this.engaged.push('previousWeeklyBike') },
		previousWeeklyTransit(val) { this.engaged.push('previousWeeklyTransit') },
		previousWeeklyMisc(val) { this.engaged.push('previousWeeklyMisc') },
		previousWeeklyCarCoride(val) { this.engaged.push('previousWeeklyCarCoride') },
		previousWeeklyElectricity(val) { this.engaged.push('previousWeeklyElectricity') },
		previousWeeklyGas(val) { this.engaged.push('previousWeeklyGas') },
		previousWeeklyHybrid(val) { this.engaged.push('previousWeeklyHybrid') },

		previousLeisureWeeklyCar(val) { this.engaged.push('previousLeisureWeeklyCar') },
		previousLeisureWeeklyWalking(val) { this.engaged.push('previousLeisureWeeklyWalking') },
		previousLeisureWeeklyBike(val) { this.engaged.push('previousLeisureWeeklyBike') },
		previousLeisureWeeklyTransit(val) { this.engaged.push('previousLeisureWeeklyTransit') },
		previousLeisureWeeklyMisc(val) { this.engaged.push('previousLeisureWeeklyMisc') },
		previousLeisureWeeklyCarCoride(val) { this.engaged.push('previousLeisureWeeklyCarCoride') },
		previousLeisureWeeklyElectricity(val) { this.engaged.push('previousLeisureWeeklyElectricity') },
		previousLeisureWeeklyGas(val) { this.engaged.push('previousLeisureWeeklyGas') },
		previousLeisureWeeklyHybrid(val) { this.engaged.push('previousLeisureWeeklyHybrid') },

		usedResvana(val) { this.engaged.push('usedResvana') },
		resvanaEffect(val) { this.engaged.push('resvanaEffect') },
		resvanaRecommend(val) { this.engaged.push('resvanaRecommend') },
		'more.walking': function (val) { this.engaged.push('moreWalking') },
		'more.biking': function (val) { this.engaged.push('moreBiking') },
		'more.transit': function (val) { this.engaged.push('moreTransit') },
		'more.car': function (val) { this.engaged.push('moreCar') },

		alwaysWalkAndBike(val) {
			if (val) {
				this.sustainabilityWish = null
			}
		}
	},

	methods: {
		selectFrequency(property, value) {
			this[property] = value
		},

		selectModeOfTransport(mode) {
			this.previousMainModeOfTransport = mode
		},

		selectLeisureModeOfTransport(mode) {
			this.previousLeisureMainModeOfTransport = mode
		},

		confirmFirstStep() {
			if ( ! this.previousMainModeOfTransport) {
				alert('Var god och välj ditt huvudsakliga färdsätt')
				return
			}

			this.firstStepConfirmed = true
		},

		nextStep() {
			if ( ! this.validate()) {
				alert('Var god och fyll i alla rödmarkerade fält')
				return
			}

			window.scrollTo(0, 0)
			this.stepIndex++
			this.saveState()
		},

		validate() {
			let required = this.required[this.stepIndex]

			// Determine which fields are engaged with (i.e. filled)
			// let engaged = []
			// for (const property in this.$data) {
			// 	if (this.$data[property] instanceof Array) {
			// 		if (this.$data[property].length > 0) {
			// 			engaged.push(property)
			// 		}
			// 	} else {
			// 		if (this.$data[property] !== null) {
			// 			engaged.push(property)
			// 		}
			// 	}
			// }

			if (this.stepIndex === 0) {
				if (parseInt(this.previousFrequencyWalk) > 0) { required.push('previousWeeklyWalking') }
				if (parseInt(this.previousFrequencyBike) > 0) { required.push('previousWeeklyBike') }
				if (parseInt(this.previousFrequencyTransit) > 0) { required.push('previousWeeklyTransit') }
				if (parseInt(this.previousFrequencyCar) > 0) { required.push('previousWeeklyCar') }
				if (parseInt(this.previousFrequencyCarCoride) > 0) { required.push('previousWeeklyCarCoride') }
				if (parseInt(this.previousFrequencyMisc) > 0) { required.push('previousWeeklyMisc') }

				if (this.previousFrequencyWalk || this.previousFrequencyBike || this.previousFrequencyTransit || this.previousFrequencyCar || this.previousFrequencyCarCoride || this.previousFrequencyMisc) {
					required.push('previousNumberOfTrips')
				}
			}

			if (this.stepIndex === 1) {
				if (parseInt(this.previousLeisureFrequencyWalk) > 0) { required.push('previousLeisureWeeklyWalking') }
				if (parseInt(this.previousLeisureFrequencyBike) > 0) { required.push('previousLeisureWeeklyBike') }
				if (parseInt(this.previousLeisureFrequencyTransit) > 0) { required.push('previousLeisureWeeklyTransit') }
				if (parseInt(this.previousLeisureFrequencyCar) > 0) { required.push('previousLeisureWeeklyCar') }
				if (parseInt(this.previousLeisureFrequencyCarCoride) > 0) { required.push('previousLeisureWeeklyCarCoride') }
				if (parseInt(this.previousLeisureFrequencyMisc) > 0) { required.push('previousLeisureWeeklyMisc') }

				if (this.previousLeisureFrequencyWalk || this.previousLeisureFrequencyBike || this.previousLeisureFrequencyTransit || this.previousLeisureFrequencyCar || this.previousLeisureFrequencyCarCoride || this.previousLeisureFrequencyMisc) {
					required.push('previousLeisureNumberOfTrips')
				}
			}

			if (this.stepIndex === 2) {
				if (this.usedResvana === 'Ja') {
					required = ['moreWalking', 'moreBiking', 'moreTransit', 'moreCar']
				}
			}

			if (this.stepIndex === 4) {
				if (this.alwaysWalkAndBike) {
					required = required.filter(v => ! v.includes('sustainabilityWish'))
				}
			}

			this.errors = required.filter(key => {
				return ! this.engaged.includes(key) || (this.$data[key] instanceof Array && this.$data[key].length === 0)
			})

			if (this.stepIndex === 0) {
				// If previousWeeklyCar > 0, then the drivmedel should add up
				if (this.previousWeeklyCar > 0 && (parseInt(this.previousWeeklyElectricity) + parseInt(this.previousWeeklyGas) + parseInt(this.previousWeeklyHybrid) != this.previousWeeklyCar)) {
					alert('Summan av drivmedel måste bli ' + this.previousWeeklyCar)
					this.errors.push('previousWeeklyElectricity')
					this.errors.push('previousWeeklyGas')
					this.errors.push('previousWeeklyHybrid')
				}
			}

			if (this.stepIndex === 1) {
				// If previousLeisureWeeklyCar > 0, then the drivmedel should add up
				if (this.previousLeisureWeeklyCar > 0 && (parseInt(this.previousLeisureWeeklyElectricity) + parseInt(this.previousLeisureWeeklyGas) + parseInt(this.previousLeisureWeeklyHybrid) != this.previousLeisureWeeklyCar)) {
					alert('Summan av drivmedel måste bli ' + this.previousLeisureWeeklyCar)
					this.errors.push('previousLeisureWeeklyElectricity')
					this.errors.push('previousLeisureWeeklyGas')
					this.errors.push('previousLeisureWeeklyHybrid')
				}
			}

			if (this.stepIndex === 5) {
				if (parseInt(this.birthYear) < 1900 || parseInt(this.birthYear) > 2022) {
					this.errors.push('birthYear')
				}

				if (this.hasCompletedPrevious) {
					required = []
					this.errors = []
				}
			}

			console.log(this.errors)

			return this.errors.length === 0
		},

		prevStep() {
			window.scrollTo(0, 0)
			this.stepIndex--
		},

		saveState() {
			axios.post(this.$apiUrl + '/api/survey/8', {
				uuid: this.uuid,
				slug: this.$route.params.slug,
				seconds_passed: performance ? parseInt(performance.now() / 1000) : null,
				...this.$data,
				completed_pages: this.stepIndex
			})
		},

		submitResponse() {
			if ( ! this.validate()) {
				alert('Var god och fyll i alla rödmarkerade fält')
				return
			}

			axios.post(this.$apiUrl + '/api/survey/8', {
				uuid: this.uuid,
				slug: this.$route.params.slug,
				seconds_passed: performance ? parseInt(performance.now() / 1000) : null,
				...this.$data,
				completed_pages: this.stepIndex + 1,
				complete: true
			}).then(res => {
				this.thankYou = true
				//this.$router.push({name: 'SurveyBPIThanks', params: {slug: this.$route.params.slug}})
            })
		}
	},

	computed: {
		hasCompletedPrevious() {
			return this.$store.state.endUser?.responses?.find(r => r.survey_id == 8 && r.complete)
		},

		previousWeeklySum() {
			return parseInt(this.previousWeeklyWalking) + parseInt(this.previousWeeklyBike) + parseInt(this.previousWeeklyTransit) + parseInt(this.previousWeeklyCar) + parseInt(this.previousWeeklyCarCoride) + parseInt(this.previousWeeklyMisc)
		},

		computedWeeklyAverage() {
			if ( ! this.previousNumberOfTrips) {
				return 0
			}

			return (this.previousWeeklySum / this.previousNumberOfTrips).toFixed(0).replace('.', ',')
		},

		yearlyDistance() {
			return this.previousWeeklySum * 52
		},

		previousLeisureWeeklySum() {
			return parseInt(this.previousLeisureWeeklyWalking) + parseInt(this.previousLeisureWeeklyBike) + parseInt(this.previousLeisureWeeklyTransit) + parseInt(this.previousLeisureWeeklyCar) + parseInt(this.previousLeisureWeeklyCarCoride) + parseInt(this.previousLeisureWeeklyMisc)
		},

		previousLeisureComputedWeeklyAverage() {
			if ( ! this.previousLeisureNumberOfTrips) {
				return 0
			}

			return (this.previousLeisureWeeklySum / this.previousLeisureNumberOfTrips).toFixed(0).replace('.', ',')
		},

		previousLeisureYearlyDistance() {
			return this.previousLeisureWeeklySum * 52
		},
	}
}
</script>
